import { useEffect } from 'react';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';

import type { PortalPartnerLoginResponse } from '../useApi/usePostPortalPartnerLogin';

const usePartnerLoginDialogue = (response?: PortalPartnerLoginResponse): { showDialogue: () => void } => {
  const errorMessage: string = response?.errorMessage || '';

  const { provideProps, showDialogue } = useConfirmationDialogue();

  const messageMap: { [key: string]: string } = {
    'Required parameter(s) missing: Username': 'Please provide a username.',
    'Required parameter(s) missing: Password': 'Please provide a password.',
    'Required parameter(s) missing: Username, Password': 'Please provide a username and password.',
    'Invalid Username!': 'An invalid username was provided.',
    'Invalid Password!': 'An invalid password was provided.',
  };

  useEffect(() => {
    const handlers = {
      errorMessage: () => {
        provideProps({
          title: 'Unsuccessful login! There is a problem with your login credentials.',
          subTitle: messageMap[errorMessage] || errorMessage,
          status: 'error',
          confirm: {
            label: 'Stay here and try again',
            action: () => {},
          },
        });
      },
    };

    if (errorMessage) return handlers.errorMessage();

    return handlers.errorMessage();
  }, [errorMessage]);

  return { showDialogue };
};

export default usePartnerLoginDialogue;
